import React from 'react';
import { Box, Typography, Stack, Chip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

const ProjectLinks = ({
    links,
    chipSx,
    stackSx
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    if (!links || (!links.website && !links.playStore && !links.appStore)) {
        return null;
    }

    const linkItems = [
        {
            key: 'website',
            label: t('pages.home.portfolio.modal.visit_website'),
            icon: <LanguageIcon fontSize="small" />,
            url: links.website
        },
        {
            key: 'playStore',
            label: t('pages.home.portfolio.modal.play_store'),
            icon: <PlayArrowIcon fontSize="small" />,
            url: links.playStore
        },
        {
            key: 'appStore',
            label: t('pages.home.portfolio.modal.app_store'),
            icon: <SmartphoneIcon fontSize="small" />,
            url: links.appStore
        }
    ].filter(item => item.url);

    if (linkItems.length === 0) return null;

    return (
        <Stack 
            direction="row" 
            flexWrap="wrap" 
            {...stackSx} 
            useFlexGap
        >
            {linkItems.map((item) => (
                <Chip
                    key={item.key}
                    label={item.label}
                    icon={item.icon}
                    component="a"
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    clickable
                    sx={{
                        backgroundColor: "grey.100",
                        color: theme.palette.custom.tagText,
                        borderRadius: '0.75rem',
                        fontWeight: 500,
                        py: 2,
                        ...chipSx
                    }}
                />
            ))}
        </Stack>
    );
};

export default ProjectLinks;
